<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <div class="pb-1"><modal-link modal-id="How to Use"></modal-link>{{ title }}</div>
      <div class="ml-auto">
        <span class="wizard-icon">
          <!--
            <font-awesome-icon  v-tooltip="tooltipConfigShow" :icon="['fas', 'hat-wizard']" @click="$root.toggleWizardContent()"/>
          -->
          <i class="fa-duotone fa-hat-wizard" aria-hidden="true" @click="$root.toggleWizardContent()"></i>
        </span>
        <i v-show="this.$parent.displayShowMenuIcon && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
        <i v-show="this.$parent.displayShowMenuIcon && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="$parent.toggleHeaderMenu()"></i>
      </div>
    </div>
    <company-menu></company-menu>
    <div v-show="$root.getShowWizardContent()" class="wizard-content">
      <div class="wizard-content-column-two-entries wizard-border col-4">
        <div class="w-100 d-flex">
          <div class="circle">1</div>
          <div class="wizard-text">
            Select the Organization from the top-left menu in the wRatings System to control the chart colors for all surveys in that Organization.
          </div>
        </div>
        <div class="w-100 d-flex pt-2">
          <div class="circle">2</div>
          <div class="wizard-text">
            Enter the hex code for a color or click the color to modify any color. The system saves color changes automatically. Click the Reset button to revert all changes for that Area back to the default settings.
          </div>
        </div>
      </div>
      <div class="wizard-content-column-two-entries wizard-border col-4">
        <div class="w-100 d-flex">
          <div class="circle">3</div>
          <div class="wizard-text">
            Chart Core colors control how the Expectations bars and Company X’s appear in all charts. The system defaults Expectations to green to represent where growth can be achieved. To change colors for Competitors, contact your wRatings Advisor.

          </div>
        </div>
        <div class="w-100 d-flex  pt-2">
          <div class="circle">4</div>
          <div class="wizard-text">
            Pricing Power represents how much more respondents are willing to pay if Expectations are met. 
          </div>
        </div>
      </div>
      <div class="wizard-content-column-two-entries wizard-border col-4">
        <div class="w-100 d-flex">
          <div class="circle">5</div>  
          <div class="wizard-text">
            Benchmark Companies appear on all charts in the order you select them. To standardize benchmark colors, select them in identical order.
          </div>      
        </div>
        <div class="w-100 d-flex pt-3">
          <div class="circle">6</div>  
          <div class="wizard-text">
            They system defaults colors for Match Profiles by Time Period so that previous survey waves are lighter to fade into the background. Darker colors represent more current survey waves.
          </div>      
        </div>
        <div class="w-100 d-flex pt-3">
          <div class="circle">7</div>  
          <div class="wizard-text">
            Set colors for Match by Saved Card or Survey Groups to compare segments or groups to each other.
          </div>      
        </div>
      </div>
    </div>
    <div v-if="getDisplayView()" class="client-settings">
      <div class="row">
        <div class="settings-section-column col-5">
          <div class="settings-for-organization"> 
            <div class="settings-for-organization-header">Settings For:</div>
            <div class="settings-organization">{{ clientName }}</div>
          </div>
          <div class="settings-section">
            <div class="settings-section-header">
              <h4 class="card-title text-primary">Chart Core</h4>
              <button type="submit" class="btn btn-primary" @click="resetChartCore" :disabled="isSavingColor">Reset</button>
            </div>
            <div class="settings-sub-section">
              <div class="col-12 no-gutters pl-0 pr-0">            
                <div v-for="(chartCoreSetting, idxChartCore) in coreColors" v-bind:key="idxChartCore" class="form-group form-inline mb-0">
                  <label :for="chartCoreSetting.displayName" class="col-3 pl-0">{{ chartCoreSetting.displayName }}</label>
                  <input
                    type="text"
                    :disabled="isSavingColor"
                    class="form-control"
                    :value="chartCoreSetting.clientSettingValue"
                    @blur="saveColorEvent(chartCoreSetting.clientSettingTypeName, chartCoreSetting.clientSettingValue, $event)"
                  />
                  <button
                    class="fg-color-sample"
                    :disabled="isSavingColor"
                    @click="pickColorForClientSetting(chartCoreSetting.clientSettingTypeName, chartCoreSetting.clientSettingValue)"
                    :style="{ background: chartCoreSetting.clientSettingValue }"
                  ></button>
                </div>
              </div>  
            </div>  
          </div>
          <div class="settings-message"> 
            Colors are set at an organization level. To change colors for a different organization, select a new organization in the top-left menu at top of page.
          </div>
          <div class="settings-section">
            <div class="settings-section-header">
              <h4 class="card-title text-primary">Match by Time Period</h4>
              <button type="submit" class="btn btn-primary" @click="resetSection('match-by-time-period')" :disabled="isSavingColor">Reset</button>
            </div>
            <div class="settings-sub-section">
              <div class="col-12 no-gutters">
                <div class="settings-sub-section-header">
                  <div class="col-3">&nbsp;</div>
                  <div>Company</div>
                </div>
                <div
                  v-for="(matchByTimePeriodCompanySetting, idxMatchByTimePeriodCompany) in matchByTimePeriodCompanyColors"
                  v-bind:key="idxMatchByTimePeriodCompany"
                  class="form-group form-inline mb-0"
                >
                  <label :for="matchByTimePeriodCompanySetting.displayName" class="col-3">{{ matchByTimePeriodCompanySetting.displayName }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="isSavingColor"
                    :value="matchByTimePeriodCompanySetting.clientSettingValue"
                    @blur="saveColorEvent(matchByTimePeriodCompanySetting.clientSettingTypeName, matchByTimePeriodCompanySetting.clientSettingValue, $event, matchByTimePeriodCompanySetting.sequenceNumber)"
                  />
                  <button
                    class="fg-color-sample"
                    :disabled="isSavingColor"
                    @click="pickColorForClientSetting(matchByTimePeriodCompanySetting.clientSettingTypeName, matchByTimePeriodCompanySetting.clientSettingValue, matchByTimePeriodCompanySetting.sequenceNumber)"
                    :style="{ background: matchByTimePeriodCompanySetting.clientSettingValue }"
                  ></button>
                </div>
              </div>
            </div>
          </div>
          <div class="settings-section">
            <div class="settings-section-header">
              <h4 class="card-title text-primary">Match by Saved Card</h4>
              <button type="submit" class="btn btn-primary" @click="resetSection('match-by-saved-card')" :disabled="isSavingColor">Reset</button>
            </div>
            <div class="settings-sub-section">
              <div class="col-12 no-gutters">
                <div class="settings-sub-section-header">
                  <div class="col-3">&nbsp;</div>
                  <div>Company</div>
                </div>
                <div
                  v-for="(matchBySavedCardCompanySetting, idxMatchBySavedCardCompany) in matchBySavedCardCompanyColors"
                  v-bind:key="idxMatchBySavedCardCompany"
                  class="form-group form-inline mb-0"
                >
                  <label :for="matchBySavedCardCompanySetting.displayName" class="col-3">{{ matchBySavedCardCompanySetting.displayName }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="isSavingColor"
                    :value="matchBySavedCardCompanySetting.clientSettingValue"
                    @blur="saveColorEvent(matchBySavedCardCompanySetting.clientSettingTypeName, matchBySavedCardCompanySetting.clientSettingValue, $event, matchBySavedCardCompanySetting.sequenceNumber)"
                  />
                  <button
                    class="fg-color-sample"
                    :disabled="isSavingColor"
                    @click="pickColorForClientSetting(matchBySavedCardCompanySetting.clientSettingTypeName, matchBySavedCardCompanySetting.clientSettingValue, matchBySavedCardCompanySetting.sequenceNumber)"
                    :style="{ background: matchBySavedCardCompanySetting.clientSettingValue }"
                  ></button>
                </div>
              </div>
            </div>
          </div>
          <div class="settings-section">
            <div class="settings-section-header">
              <h4 class="card-title text-primary">Match by Survey Group and Survey</h4>
              <button type="submit" class="btn btn-primary" @click="resetSection('match-by-survey')" :disabled="isSavingColor">Reset</button>
            </div>
            <div class="settings-sub-section">
              <div class="col-12 no-gutters">
                <div class="settings-sub-section-header">
                  <div class="col-3">&nbsp;</div>
                  <div>Company</div>
                </div>
                <div
                  v-for="(matchBySurveyCompanySetting, idxMatchBySurveyCompany) in matchBySurveyCompanyColors"
                  v-bind:key="idxMatchBySurveyCompany"
                  class="form-group form-inline mb-0"
                >
                  <label :for="matchBySurveyCompanySetting.displayName" class="col-3">{{ matchBySurveyCompanySetting.displayName }}</label>
                  <input
                    type="text"
                    class="form-control"
                    :disabled="isSavingColor"
                    :value="matchBySurveyCompanySetting.clientSettingValue"
                    @blur="saveColorEvent(matchBySurveyCompanySetting.clientSettingTypeName, matchBySurveyCompanySetting.clientSettingValue, $event, matchBySurveyCompanySetting.sequenceNumber)"
                  />
                  <button
                    class="fg-color-sample"
                    :disabled="isSavingColor"
                    @click="pickColorForClientSetting(matchBySurveyCompanySetting.clientSettingTypeName, matchBySurveyCompanySetting.clientSettingValue, matchBySurveyCompanySetting.sequenceNumber)"
                    :style="{ background: matchBySurveyCompanySetting.clientSettingValue }"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <color-picker ref="colorPickerForClientSetting" modal-name="main-client-setting-color-picker" @save="updateClientSetting" />
    <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
  </div>
</template>
<script>
import CompanyMixins from "../../mixins/CompanyMixins.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";
import CompanyMenu from "../../views/menu/CompanyMenu.vue";
import Modal from "../../components/Modal.vue";
import ModalLink from "../../components/ModalLink.vue";
import AdminService from "../../services/admin.service";
import ClientService from "../../services/client.service";
import ContentService from "../../services/content.service";
import ClientSettingsService from "../../services/client.settings.service";
import ColorService from "../../services/color.service";
import ColorPicker from "../../modals/ColorPicker.vue";

export default {
  name: "ClientSettings",
  mixins: [CompanyMixins, ContentMixins],
  components: {
    Modal,
    ModalLink,
    CompanyMenu,
    ColorPicker,
  },
  props: {},
  data() {
    return {
      pageNumber: 2,
      title: "Settings",
      isSavingColor: false,
      tooltipConfigShow: ContentService.getWizardTooltip(),     
      settings: [],
      settingValue: "",
      settingType: "",
      settingSequenceNumber: -1,
      coreColors: [],
      w50Colors: [],
      matchByTimePeriodExpectationsColors: [],
      matchByTimePeriodCompanyColors: [],
      matchBySavedCardExpectationsColors: [],
      matchBySavedCardCompanyColors: [],
      matchBySurveyExpectationsColors: [],
      matchBySurveyCompanyColors: [],
    };
  },
  methods: {
    async resetChartCore() {
      this.$root.processServerRequest("Resetting colors");
      ClientSettingsService.resetClientSettings(this.clientCode, ColorService.DEFAULT_CORE_COLORS, this.processClientSettings);
      let defaultClientColor = ColorService.getValue("company-color", ColorService.DEFAULT_CORE_COLORS);
      ClientService.saveClientColor(this.clientCode, defaultClientColor, this.saveClientColorCallback, this);
    },
    async resetSection(type) {
      this.$root.processServerRequest("Resetting colors");
      if (type == "w-30") {
        await ClientSettingsService.resetClientSettings(this.clientCode, ColorService.DEFAULT_W50_COLORS, this.processClientSettings);
      } else if (type == "match-by-saved-card") {
        let settings = [].concat(ColorService.DEFAULT_MATCH_BY_SAVED_CARD_EXPECTATIONS_COLORS, ColorService.DEFAULT_MATCH_BY_SAVED_CARD_COMPANY_COLORS);
        await ClientSettingsService.resetClientSettings(this.clientCode, settings, this.processClientSettings);
      } else if (type == "match-by-time-period") {
        let settings = [].concat(ColorService.DEFAULT_MATCH_BY_TIME_PERIOD_EXPECTATIONS_COLORS, ColorService.DEFAULT_MATCH_BY_TIME_PERIOD_COMPANY_COLORS);
        await ClientSettingsService.resetClientSettings(this.clientCode, settings, this.processClientSettings);
      } else if (type == "match-by-survey") {
        let settings = [].concat(ColorService.DEFAULT_MATCH_BY_SURVEY_EXPECTATIONS_COLORS, ColorService.DEFAULT_MATCH_BY_SURVEY_COMPANY_COLORS);
        await ClientSettingsService.resetClientSettings(this.clientCode, settings, this.processClientSettings);
      }
    },
    saveColorEvent(type, originalValue, event, sequenceNumber = 1){
      if (originalValue !== event.target.value){
        this.settingType = type;
        this.settingSequenceNumber = sequenceNumber;        
        this.updateClientSetting(event.target.value);
      }
    },    
    pickColorForClientSetting(type, value, sequenceNumber = 1) {
      this.settingType = type;
      this.settingValue = value;
      this.settingSequenceNumber = sequenceNumber;
      this.$refs.colorPickerForClientSetting.$data.currentColor = {};
      this.$refs.colorPickerForClientSetting.$data.currentColor.hex = this.settingValue;
      this.$refs.colorPickerForClientSetting.$data.currentColor.hex8 = this.settingValue;
      this.$modal.show("main-client-setting-color-picker");
    },
    updateClientSetting(result) {
      this.settingValue = result;
      this.saveClientSetting();
    },
    async saveClientSetting() {
      this.$root.processServerRequest("Saving company setting");
      this.isSavingColor = true;
      if (this.settingType === "company-color") {
        ClientService.saveClientColor(this.clientCode, this.settingValue, this.saveClientColorCallback, this);
      } else {
        ClientSettingsService.saveClientSetting(this.clientCode, this.settingType, this.settingValue, this.settingSequenceNumber,this.saveClientSettingCallback, this);
      }
    },
    saveSettingValues() {
      ColorService.setValue(this.settingType, this.settingValue, this.coreColors);
      ColorService.setValue(this.settingType, this.settingValue, this.w50Colors);
      ColorService.setValue(this.settingType, this.settingValue, this.matchByTimePeriodExpectationsColors);
      ColorService.setValue(this.settingType, this.settingValue, this.matchByTimePeriodCompanyColors);
      ColorService.setValue(this.settingType, this.settingValue, this.matchBySavedCardExpectationsColors);
      ColorService.setValue(this.settingType, this.settingValue, this.matchBySavedCardCompanyColors);
      ColorService.setValue(this.settingType, this.settingValue, this.matchBySurveyExpectationsColors);
      ColorService.setValue(this.settingType, this.settingValue, this.matchBySurveyCompanyColors);
    },
    saveClientSettingCallback(response) {
      this.isSavingColor = false;
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.saveSettingValues();
        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message }));
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
    },
    saveClientColorCallback(response) {
      this.isSavingColor = false;
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        let returnClient = JSON.parse(response.data.data);
        this.$parent.clientObject.color = returnClient.color;        
        ClientService.saveClient(this.$parent.clientObject);
        var coreSetting = this.coreColors.find((x) => x.clientSettingTypeName == "company-color");
        if (typeof coreSetting != "undefined") {
          coreSetting.clientSettingValue = this.$parent.clientObject.color;
        }
        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message }));
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
    },
    processClientSettings(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.settings = response.data.data;
        this.w50Colors = ColorService.setColors(this.settings, ColorService.DEFAULT_W50_COLORS);
        this.coreColors = ColorService.setColors(this.settings, ColorService.DEFAULT_CORE_COLORS);
        this.matchByTimePeriodExpectationsColors = ColorService.setColors(this.settings, ColorService.DEFAULT_MATCH_BY_TIME_PERIOD_EXPECTATIONS_COLORS);
        this.matchByTimePeriodCompanyColors = ColorService.setColors(this.settings, ColorService.DEFAULT_MATCH_BY_TIME_PERIOD_COMPANY_COLORS);
        this.matchBySavedCardExpectationsColors = ColorService.setColors(this.settings, ColorService.DEFAULT_MATCH_BY_SAVED_CARD_EXPECTATIONS_COLORS);
        this.matchBySavedCardCompanyColors = ColorService.setColors(this.settings, ColorService.DEFAULT_MATCH_BY_SAVED_CARD_COMPANY_COLORS);
        this.matchBySurveyExpectationsColors = ColorService.setColors(this.settings, ColorService.DEFAULT_MATCH_BY_SURVEY_EXPECTATIONS_COLORS);
        this.matchBySurveyCompanyColors = ColorService.setColors(this.settings, ColorService.DEFAULT_MATCH_BY_SURVEY_COMPANY_COLORS);

        var coreSetting = this.coreColors.find((x) => x.clientSettingTypeName == "company-color");
        if (typeof coreSetting != "undefined") {
          coreSetting.clientSettingValue = this.$parent.clientObject.color;
        }
        this.setDisplayView(true);
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
    },
    loadData: function () {
      this.$root.processServerRequest("Loading settings");
      ClientSettingsService.getClientSettings(this.clientCode, this.processClientSettings, this);
    },
  },
  created() {},
  mounted() {},
};
</script>
